module.exports = __webpack_public_path__ + "media/hyper/images/mail_sent-e0685cac9a300270a1a5dd196538d773.svg";